import { useState } from "react";
const usePagination = ({ totalCount, initialPage = 1, initialPageSize }) => {
  const [page, setPage] = useState(initialPage || 1);
  const [pageSize, setPageSize] = useState(initialPageSize || 50);
  return {
    page: page,
    setPage: setPage,
    pageSize: pageSize,
    setFetchSize: setPageSize,
    totalCount: totalCount || 0,
    initialPage: initialPage || 1,
    initialPageSize: initialPageSize || 50
  };
};

export default usePagination;

usePagination.defaultProps = {
  totalCount: 0,
  initialPage: 1,
  initialPageSize: 50
};
